import camelCase from 'lodash.camelcase'

export default camelCase
